// extracted by mini-css-extract-plugin
module.exports = {"benefitsModal__main":"BenefitsModalMobile_benefitsModal__main__U7uTv"};